import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  workOrder: null,
  workOrderList: [],
};

const route = "modules/workOrders/views/trackerTab/modals/deleteWorkOrder/redux/slice";

export const workOrderDeleteWorkOrder = createAsyncThunk("manage/deleteWorkOrder/bulkDeleteWorkOrder", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `mutation bulkDeleteWorkOrder ($ids: [Int!]) {
        result: bulkDeleteWorkOrder (ids: $ids)
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

    return { delete: response?.result }

  } catch (exc) {
    ExceptionManager(exc, route, "bulkDeleteWorkOrder");
    return rejectWithValue(exc);
  }
}
);


const workOrdersDeleteWorkOrderRedux = createSlice({
  name: "workOrders/deleteWorkOrder",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalDeleteWorkOrder(state, action) {
      state.open = true;
      state.workOrder = action?.payload?.workOrder;
      state.workOrderList = action?.payload?.workOrderList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageWorkOrderType
    builder.addCase(workOrderDeleteWorkOrder.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrderDeleteWorkOrder.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(workOrderDeleteWorkOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersDeleteWorkOrderRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteWorkOrder } = actions;

// Export the reducer, either as a default or named export
export default reducer;